"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormatCode;
(function (FormatCode) {
    FormatCode["LONG_DATE"] = "L";
    FormatCode["SHORT_DATE"] = "S";
    FormatCode["NUMBER"] = "N";
    FormatCode["CURRENCY"] = "C";
    FormatCode["TIME"] = "T";
    FormatCode["CUSTOM"] = "*";
    FormatCode["CUSTOM_ICU"] = "i";
    FormatCode["CUSTOM_NUMBER"] = "n";
    FormatCode["CUSTOM_CURRENCY"] = "c";
    FormatCode["CUSTOM_SCIENTIFIC"] = "e";
    FormatCode["CUSTOM_PERCENTAGE"] = "p";
})(FormatCode = exports.FormatCode || (exports.FormatCode = {}));
var FormatDataType;
(function (FormatDataType) {
    FormatDataType["FORMAT_NUMBER"] = "FORMAT_NUMBER";
    FormatDataType["FORMAT_DATE_TIME"] = "FORMAT_DATE_TIME";
    FormatDataType["FORMAT_AUTO"] = "FORMAT_AUTO";
})(FormatDataType = exports.FormatDataType || (exports.FormatDataType = {}));
var autoFormat = { dataType: FormatDataType.FORMAT_AUTO };
/**
 * This function takes a format string and parses it into formatting components.
 *
 * @export
 * @param {string} formatString
 * @returns {FormatInfo}
 */
function parseFormatString(formatString) {
    if (!formatString || formatString.length === 0) {
        return autoFormat;
    }
    var tokenizer = new Tokenizer(formatString);
    // TODO: TFSID 1006678: Support non-US-English locales.
    // Look at the first character of the string to determine the format type.
    switch (tokenizer.next()) {
        case FormatCode.CURRENCY:
            return parseCurrency(tokenizer);
        case FormatCode.CUSTOM_CURRENCY:
            return parseCustomCurrency(tokenizer);
        case FormatCode.CUSTOM_NUMBER:
            return parseCustomNumber(tokenizer);
        case FormatCode.CUSTOM_PERCENTAGE:
            return parseCustomPercentage(tokenizer);
        default:
            return autoFormat;
    }
}
exports.parseFormatString = parseFormatString;
/**
 * A currency format string looks like 'C1033%'.  The numbers in the middle are the locale ID
 * of the currency symbol to use.  So 1033 = en_US = '$'.
 * @param tokenizer the format string to be parsed
 */
function parseCurrency(tokenizer) {
    var prefixSymbol = '';
    var postfixSymbol = '';
    var lcid = extractLcid(tokenizer);
    switch (lcid) {
        case 1033:
            prefixSymbol = '$';
            break;
        case 1031:
            postfixSymbol = '€';
            break;
        default:
            break;
    }
    return {
        dataType: FormatDataType.FORMAT_NUMBER,
        isPercentage: false,
        isCurrency: true,
        prefixSymbol: prefixSymbol,
        postfixSymbol: postfixSymbol,
    };
}
/**
 * Custom currency format strings look like 'c"$"##0.00;"$"(##0.00)'.
 * @param tokenizer the format string to be parsed
 */
function parseCustomCurrency(tokenizer) {
    var symbols = parsePrefixPostFixSymbols(tokenizer);
    return {
        dataType: FormatDataType.FORMAT_NUMBER,
        isPercentage: false,
        isCurrency: true,
        prefixSymbol: symbols[0],
        postfixSymbol: symbols[1],
    };
}
/**
 * Custom number format strings look like 'n##0.00"%";-##0.00"%"'.
 * @param tokenizer the format string to be parsed
 */
function parseCustomNumber(tokenizer) {
    var symbols = parsePrefixPostFixSymbols(tokenizer);
    // If the format string contains a '%' we still just want to format it as a regular number.
    // Identifying it as a percentage format would cause the number to get multiplied by 100.
    return {
        dataType: FormatDataType.FORMAT_NUMBER,
        isPercentage: false,
        isCurrency: false,
        prefixSymbol: symbols[0],
        postfixSymbol: symbols[1],
    };
}
function parsePrefixPostFixSymbols(tokenizer) {
    var prefixSymbol = '';
    var postfixSymbol = '';
    var cur = tokenizer.next();
    // Check for a currency symbol prefix.
    if (cur === '"') {
        cur = tokenizer.next();
        while (cur && cur !== '"') {
            prefixSymbol += cur;
            cur = tokenizer.next();
        }
        cur = tokenizer.next();
    }
    // For now skip over the number part.
    while (cur && cur !== ';') {
        // Check for a currency symbol postfix.
        if (cur === '"') {
            cur = tokenizer.next();
            while (cur && cur !== '"') {
                postfixSymbol += cur;
                cur = tokenizer.next();
            }
        }
        cur = tokenizer.next();
    }
    return [prefixSymbol, postfixSymbol];
}
/**
 * The custom percentage string looks like 'p0.00%'.
 * @param tokenizer format string to be parsed
 */
function parseCustomPercentage(tokenizer) {
    // Since we aren't parsing the decimal places yet, just return the format info.
    return {
        dataType: FormatDataType.FORMAT_NUMBER,
        isPercentage: true,
        isCurrency: false,
    };
}
function extractLcid(tokenizer) {
    var lcid = '';
    var cur = tokenizer.next();
    while (cur && cur !== '%') {
        lcid += cur;
        cur = tokenizer.next();
    }
    return +lcid;
}
var Tokenizer = /** @class */ (function () {
    function Tokenizer(formatString) {
        this.pos = 0;
        this.formatString = formatString;
        this.len = formatString.length || 0;
    }
    Tokenizer.prototype.next = function () {
        if (this.pos === this.len) {
            return '';
        }
        return this.formatString.charAt(this.pos++);
    };
    return Tokenizer;
}());
//# sourceMappingURL=formatParser.js.map